import { useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useVerifyEmailMutation, useResendOtpMutation } from "@/features/auth/authApiSlice";
import { SuccessNotify, FailedNotify } from "@/constants/tostify";

export const useVerifyDigitsState = () => {
  const { email } = useParams();
  const navigate = useNavigate();

  const [verifyEmail, { isLoading: isVerifying }] = useVerifyEmailMutation();
  const [resendOtpReq, { isLoading: isResending }] = useResendOtpMutation();

  const [resendotp] = useState({ email: email });
  const [getotp, setGetotp] = useState({
    one1: "",
    one2: "",
    one3: "",
    one4: "",
    one5: "",
    one6: "",
  });

  const refs = {
    one1: useRef(),
    one2: useRef(),
    one3: useRef(),
    one4: useRef(),
    one5: useRef(),
    one6: useRef(),
  };

  const handleValue = (e) => {
    setGetotp((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

    if (e.target.value.length === 1) {
      if (e.target.name === "one1") refs.one2.current?.focus();
      else if (e.target.name === "one2") refs.one3.current?.focus();
      else if (e.target.name === "one3") refs.one4.current?.focus();
      else if (e.target.name === "one4") refs.one5.current?.focus();
      else if (e.target.name === "one5") refs.one6.current?.focus();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Backspace" && e.target.value === "") {
      if (e.target.name === "one2") refs.one1.current?.focus();
      else if (e.target.name === "one3") refs.one2.current?.focus();
      else if (e.target.name === "one4") refs.one3.current?.focus();
      else if (e.target.name === "one5") refs.one4.current?.focus();
      else if (e.target.name === "one6") refs.one5.current?.focus();
    }
  };

  const handleOtp = async () => {
    const otp = `${getotp.one1}${getotp.one2}${getotp.one3}${getotp.one4}${getotp.one5}${getotp.one6}`;
    
    if (otp.length < 6) {
      FailedNotify("Please enter a valid 6-digit OTP.");
      return;
    }

    try {
      const res = await verifyEmail({ otp, email }).unwrap();
      if (res.success) {
        SuccessNotify("Email Verified Successfully! Please log in to continue.");
        setTimeout(() => {
          navigate("/");
        }, 2000);
      }
    } catch (err) {
      FailedNotify(err?.data?.message || "Something Went Wrong");
    }
  };

  const resendOtp = async () => {
    try {
      const res = await resendOtpReq(resendotp).unwrap();
      if (res.success) {
        SuccessNotify("OTP Resend");
      }
    } catch (err) {
      FailedNotify("Something Went Wrong");
    }
  };

  return {
    handleValue,
    handleKeyDown,
    handleOtp,
    resendOtp,
    isVerifying,
    isResending,
    refs,
  };
};
